import { fetchWithAuth } from '../helpers';
import { getApiUrl } from '../config/api';

const HEADERS = { 'ngrok-skip-browser-warning': '69420' };

function handleResponse(res: Response) {
  return res.text().then((text: string) => {
    const data = text && JSON.parse(text);
    if (!res.ok) return Promise.reject((data && data.message) || res.statusText);
    return data;
  });
}

const getAll = () =>
  fetchWithAuth(`${getApiUrl()}/api/gifts`, { headers: HEADERS }).then(handleResponse);

const getById = (id: number) =>
  fetchWithAuth(`${getApiUrl()}/api/gifts/${id}`, { headers: HEADERS }).then(handleResponse);

const create = (formData: FormData) =>
  fetchWithAuth(`${getApiUrl()}/api/gifts`, {
    method: 'POST',
    headers: { 'ngrok-skip-browser-warning': '69420' },
    body: formData,
  }).then(handleResponse);

const update = (id: number, formData: FormData) =>
  fetchWithAuth(`${getApiUrl()}/api/gifts/${id}`, {
    method: 'PUT',
    headers: { 'ngrok-skip-browser-warning': '69420' },
    body: formData,
  }).then(handleResponse);

const remove = (id: number) =>
  fetchWithAuth(`${getApiUrl()}/api/gifts/${id}`, {
    method: 'DELETE',
    headers: HEADERS,
  }).then((res) => { if (!res.ok) throw new Error('Xóa thất bại'); });

const giveGift = (
  id: number,
  data: { studentId?: number; studentName: string; quantity: number; note?: string }
) =>
  fetchWithAuth(`${getApiUrl()}/api/gifts/${id}/give`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'ngrok-skip-browser-warning': '69420' },
    body: JSON.stringify(data),
  }).then(handleResponse);

const getTransactions = (id: number) =>
  fetchWithAuth(`${getApiUrl()}/api/gifts/${id}/transactions`, {
    headers: HEADERS,
  }).then(handleResponse);

const updateTransaction = (txId: number, data: { newGiftId?: number; quantity?: number; note?: string; studentName?: string }) =>
  fetchWithAuth(`${getApiUrl()}/api/gifts/transactions/${txId}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', 'ngrok-skip-browser-warning': '69420' },
    body: JSON.stringify(data),
  }).then(handleResponse);

const deleteTransaction = (txId: number) =>
  fetchWithAuth(`${getApiUrl()}/api/gifts/transactions/${txId}`, {
    method: 'DELETE',
    headers: HEADERS,
  }).then((res) => { if (!res.ok && res.status !== 204) throw new Error('Huỷ thất bại'); });

const getTransactionsByStudents = (studentIds: number[]) =>
  fetchWithAuth(`${getApiUrl()}/api/gifts/transactions/by-students`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'ngrok-skip-browser-warning': '69420' },
    body: JSON.stringify({ studentIds }),
  }).then(handleResponse);

export const giftService = { getAll, getById, create, update, remove, giveGift, getTransactions, updateTransaction, deleteTransaction, getTransactionsByStudents };
